import { FC, useContext } from 'react'
import { Button, Icon } from '@components/Generic'
import { observer } from 'mobx-react'
import { StoreContext } from '@store/Root.store'
import { cx } from '@/utils/cx'
import './Addons.css'

interface ScrollDocumentButtonProps {
  onClick?: () => void
  bottomOffset?: number
  showScrollToBottomButton?: boolean
}

export const ScrollDocumentButton: FC<ScrollDocumentButtonProps> = observer(
  ({ onClick, bottomOffset = 0, showScrollToBottomButton = false }) => {
    const store = useContext(StoreContext)
    const { signDocumentPage: trans } = store.TranslationsState.translations

    const scrollToBottom = () => {
      const element = document.querySelector('.pdf-viewer-virtualized-list')

      if (element) {
        element.scrollTop = element.scrollHeight

        onClick && onClick()
      }
    }

    return (
      <div
        className={cx(
          'pdf-ocg-addons__scroll-document-button-container',
          !showScrollToBottomButton && 'pdf-ocg-addons__scroll-document-button-container--hidden'
        )}
        style={{ bottom: `calc(10px + ${bottomOffset}px)` }}
      >
        <Button onClick={scrollToBottom} tabIndex={0} dataTestid="test-scroll-bottom">
          <span className="generic__button-text">{trans.scrollButton}</span>
          <Icon color="currentColor" colorHover="currentColor" type="arrow-down" size="24px" />
        </Button>
      </div>
    )
  }
)
